import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageLayout } from './components/layout';
import { PageLoader } from './components/PageLoader';
import { useScrollToTop } from './hooks/useScrollToTop';

const Home = lazy(() => import('./pages/Home').then((m) => ({ default: m.Home })));
const Solutions = lazy(() =>
  import('./pages/Solutions').then((m) => ({ default: m.Solutions })),
);
const Expertise = lazy(() =>
  import('./pages/Expertise').then((m) => ({ default: m.Expertise })),
);
const References = lazy(() =>
  import('./pages/References').then((m) => ({ default: m.References })),
);
const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })));
const Catalogue = lazy(() =>
  import('./pages/Catalogue').then((m) => ({ default: m.Catalogue })),
);
const Contact = lazy(() =>
  import('./pages/Contact').then((m) => ({ default: m.Contact })),
);
const BusinessModel = lazy(() =>
  import('./pages/BusinessModel').then((m) => ({ default: m.BusinessModel })),
);
const Conformite = lazy(() =>
  import('./pages/Conformite').then((m) => ({ default: m.Conformite })),
);
const Status = lazy(() => import('./pages/Status').then((m) => ({ default: m.Status })));
const MentionsLegales = lazy(() =>
  import('./pages/MentionsLegales').then((m) => ({ default: m.MentionsLegales })),
);
const Blog = lazy(() => import('./pages/Blog').then((m) => ({ default: m.Blog })));
const BlogPost = lazy(() =>
  import('./pages/BlogPost').then((m) => ({ default: m.BlogPost })),
);
const Buyback = lazy(() =>
  import('./pages/Buyback').then((m) => ({ default: m.Buyback })),
);
const RepriseParcInformatique = lazy(() =>
  import('./pages/RepriseParcInformatique').then((m) => ({
    default: m.RepriseParcInformatique,
  })),
);
const NotFound = lazy(() =>
  import('./pages/NotFound').then((m) => ({ default: m.NotFound })),
);

function ScrollToTop() {
  useScrollToTop();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<LanguageLayout lang="en" />}>
            <Route path="/en" element={<Home />} />
            <Route path="/en/solutions" element={<Solutions />} />
            <Route path="/en/solutions/business-model" element={<BusinessModel />} />
            <Route path="/en/solutions/compliance" element={<Conformite />} />
            <Route path="/en/expertise" element={<Expertise />} />
            <Route path="/en/references" element={<References />} />
            <Route path="/en/about" element={<About />} />
            <Route path="/en/catalog" element={<Catalogue />} />
            <Route path="/en/contact" element={<Contact />} />
            <Route path="/en/status" element={<Status />} />
            <Route path="/en/blog" element={<Blog />} />
            <Route path="/en/blog/:slug" element={<BlogPost />} />
            <Route path="/en/buyback" element={<Buyback />} />
            <Route path="/en/it-fleet-buyback" element={<RepriseParcInformatique />} />
            <Route path="/en/legal-notice" element={<MentionsLegales />} />
            <Route path="/en/*" element={<NotFound />} />
          </Route>
          <Route element={<LanguageLayout lang="fr" />}>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/business-model" element={<BusinessModel />} />
            <Route path="/solutions/conformite" element={<Conformite />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/references" element={<References />} />
            <Route path="/about" element={<About />} />
            <Route path="/catalogue" element={<Catalogue />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/status" element={<Status />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/buyback" element={<Buyback />} />
            <Route path="/reprise-parc-informatique" element={<RepriseParcInformatique />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
